<template>
  
    <div >
      <locationbasic
        :locationnetworkslocations="LocationNetworksLocations"
        :locationCount="locationLength"
        :loading="loading"
        @locationSaved="fetchLocations()"
      ></locationbasic>
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import LocationBasic from '@/components/LocationBasic.vue';
export default {
  components: {
    locationbasic: LocationBasic
  },
  data() {
    return {
      LocationNetworksLocations: [],
      loading:true,
      locationLength: 0
    };
  },
  watch: {
    '$route.query.search':{
      immediate: true,
      handler(value){
        // this.LocationNetworksLocations= await this.search(value.search)
        this.loading=true
      if(this.$route.query.search&&value!==""&&value != null){      
        // debugger
        Api()
        .get('/locations/activeFilter',{
          params: {
          search: value,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false
          })} else if(this.$route.query.offset){
            // debugger
             Api()
        .get('/locations/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false})
            // this.fetchDevices()
            // // debugger
          }
      }
    },
    '$route.query.offset': {
       immediate: true,
      handler(value){
        // this.LocationNetworksLocations= await this.search(value.search)
        this.loading=true
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!="" &&this.$route.query.search!== null){      
        
        Api()
        .get('/locations/activeFilter',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false})
      } else if(value!==""&&value != null){
        // debugger
         Api()
        .get('/locations/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false})
      }
    },
  }
  },
  computed: {},
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/locationBasic'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },

  methods: {
    fetchLocations(){
      this.loading=true
      Api()
        .get("/Locations")
        .then(response => {
          this.LocationNetworksLocations = response.data;
          this.loading=false
        })
    },
    initialize() {
      this.$router.push({name: this.$route.name, query:{offset: '0', records: '20'}})
      // this.fetchLocations();
    }
  }
};
</script>

